import { Factory } from "@phosphor-icons/react"
import Select from "~/components/reusable/Select"

type VendorSelectorProps = {
  selectableVendors: { id: string; name: string }[]
  vendorId: string | undefined
  setVendorId: (id: string) => void
  preferredVendorIds: string[]
  className?: string
}

export function VendorSelector({
  selectableVendors,
  vendorId,
  setVendorId,
  preferredVendorIds,
  className = "w-[230px] h-9",
}: VendorSelectorProps) {
  return (
    <Select
      label="Vendor"
      className={className}
      onChange={(value) => value && setVendorId(value.id)}
      value={selectableVendors.find((vendor) => vendor.id === vendorId)}
      options={selectableVendors}
      getOptionLabel={(option) =>
        selectableVendors.length > 1 && preferredVendorIds.includes(option.id)
          ? `${option.name} (preferred)`
          : option.name
      }
      getOptionValue={(option) => option.id}
      isDisabled={selectableVendors.length === 1}
      leftIcon={<Factory />}
    />
  )
}
